import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="text-2xl font-fun text-primary-500">91</span>
            <span className={`text-lg font-heading font-bold ${scrolled || !isHome ? 'text-foreground-900' : 'text-white'}`}>
              次元
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-500'
                  : scrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-500'
                    : scrolled || !isHome
                    ? 'text-foreground-700 hover:text-primary-500'
                    : 'text-white/90 hover:text-white'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : scrolled || !isHome
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 transition-colors cursor-pointer" aria-label="搜索">
              <i className="ri-search-line text-foreground-600"></i>
            </button>
            <Link
              to="/about"
              className="px-5 py-2 bg-primary-500 text-white text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              加入社区
            </Link>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${scrolled || !isHome ? 'text-foreground-900' : 'text-white'} ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap">首页</Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 whitespace-nowrap">关于我们</Link>
            <Link
              to="/about"
              className="mt-2 px-5 py-2.5 bg-primary-500 text-white text-sm font-medium rounded-full hover:bg-primary-600 transition-colors text-center whitespace-nowrap"
            >
              加入社区
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}